import React from "react";
import { PROCESS, WHY_CHOOSE } from "../mock";
import { PageHero, Eyebrow, Icon, CtaBanner, Reveal } from "../components/shared";

export default function ProcessPage() {
  return (
    <>
      <PageHero
        crumb="Process"
        eyebrow="Our Process"
        title="Simple, Professional, Effective"
        subtitle="Six clear stages from first conversation to ongoing support, so you always know what happens next."
      />

      <section className="py-20 lg:py-28 bg-white">
        <div className="max-w-[1240px] mx-auto px-5 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-12">
            {PROCESS.map((p, i) => (
              <Reveal key={p.no} delay={(i % 3) * 90} className="border-t border-black/15 pt-6">
                <div className="font-display font-extrabold text-[#0b2545] text-[40px] leading-none">{p.no}</div>
                <h3 className="mt-5 font-display font-bold text-[20px] text-[#0b2545]">{p.title}</h3>
                <p className="mt-3 text-[15px] text-slate-600 leading-relaxed">{p.text}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 lg:py-28 bg-[#eaf2ff]">
        <div className="max-w-[1240px] mx-auto px-5 lg:px-8">
          <Reveal>
            <p className="text-[12px] font-semibold tracking-[0.25em] text-[#1e73ff] uppercase mb-5">Why Choose Us</p>
            <h2 className="font-display font-extrabold text-[#0b2545] text-[38px] lg:text-[56px] hero-heading max-w-2xl">
              The Difference Is in the Details
            </h2>
          </Reveal>
          <div className="mt-16 grid md:grid-cols-2 gap-x-16 gap-y-2">
            {WHY_CHOOSE.map((w, i) => (
              <Reveal key={i} delay={(i % 2) * 90} className="flex gap-5 py-8 border-t border-black/10">
                <div className="shrink-0 w-11 h-11 rounded-full bg-[#1e73ff] flex items-center justify-center">
                  <Icon name={w.icon} className="w-5 h-5 text-white" />
                </div>
                <div>
                  <h3 className="font-display font-bold text-[18px] text-[#0b2545]">{w.title}</h3>
                  <p className="mt-2 text-[15px] text-slate-500 leading-relaxed">{w.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CtaBanner />
    </>
  );
}
